class UpdateMobileNavigation
{
	static init()
	{
		const toggle = document.querySelector('#mobile-navigation-toggle');
		const panel = document.querySelector('#mobile-navigation');

		if(toggle === null || panel === null)
		{
			return;
		}

		const icon = toggle.querySelector('i');

		const setIsOpen = (isOpen) => {
			panel.classList.toggle('hidden', !isOpen);
			panel.classList.toggle('flex', isOpen);
			icon?.classList.toggle('fa-bars', !isOpen);
			icon?.classList.toggle('fa-xmark', isOpen);
			toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
		};

		toggle.addEventListener('click', () => setIsOpen(panel.classList.contains('hidden')));

		// Jumping to a section closes the menu; the "#" dropdown triggers are only headings here.
		panel.addEventListener('click', (event) => {
			const link = event.target.closest('a[href^="#"]');

			if(link !== null && link.getAttribute('href') !== '#')
			{
				setIsOpen(false);
			}
		});
	}
}

export default UpdateMobileNavigation;
